import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import image from "../assets/image.png";
import { Link } from "react-scroll";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <div
      name="home"
      className="w-full md:h-screen pt-20 bg-gradient-to-b from-gray-200 to-gray-300 dark:bg-gradient-to-b dark:from-gray-700 dark:to-gray-800 transition-transform scroll-mt-20"
    >
      <div className="w-full max-w-screen-lg mx-auto flex flex-col sm:flex-row items-center justify-center h-full px-4">
        
        {/* Animate only the text block */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="flex flex-col justify-center h-full text-gray-800 dark:text-gray-200 "
        >
          <h2 className="text-4xl sm:text-7xl font-bold">
            Hey there, I am Satyam Kumar Singh
          </h2>
          <p className="text-gray-800 dark:text-gray-300 py-4 max-w-md">
            I have completed my Bachelor's degree in Computer Engineering
            from IOE Purwanchal Campus, Dharan and have recently obtained
            Computer Engineer's licence from Nepal Engineering Council. 
            Currently, I'm focused on refining my skills in front-end development.
            I've completed numerous online courses in this field to enhance my expertise.
          </p>
          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-orange-400 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdKeyboardArrowRight className="ml-1" size={26} />
              </span>
            </Link>
          </div>
        </motion.div>

        {/* Image stays unaffected */}
        <motion.div initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}>
          <img
            src={image}
            alt="my profile"
            className="rounded-2xl mx-auto w-2/3 md:w-full"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Home;
